import { createSlice } from "@reduxjs/toolkit";

const addModalTextLiteratureSlice = createSlice({
  name: "addModalTextLiterature",
  initialState: {
    isOpen: false,
    error: null,
  },
  reducers: {
    openModal: (state) => {
      state.isOpen = true;
      state.error = null;
    },
    closeModal: (state) => {
      state.isOpen = false;
      state.error = null;
    },
  },
});

export const { openModal, closeModal } = addModalTextLiteratureSlice.actions;
export default addModalTextLiteratureSlice.reducer;
